import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="glitch"
export default class extends Controller {
  static targets = ["text"];

  connect() {
      // Store the original text in a data attribute
      this.element.dataset.text = this.element.textContent;
  }

  glitchOn(event) {
      this.element.classList.add('glitch-effect');
  }

  glitchOff(event) {
      this.element.classList.remove('glitch-effect');
  }
}